import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types';

export const enhance = () => {
	const EnhancedInfoWindow = (props) => {
		const { content, google, map, location, onClose } = props;

		useEffect(() => {
			if (google && map) {
				const infoContent = document.createElement('div');
				createRoot(infoContent).render(<div>{content}</div>);

				const iw = new google.maps.InfoWindow({
					content: infoContent,
					pixelOffset: new google.maps.Size(0, -26),
					position: new google.maps.LatLng(
						location.latitude,
						location.longitude,
					),
				});

				google.maps.event.addListener(iw, 'closeclick', onClose);

				iw.open(map);

				return () => {
					iw.close();
					google.maps.event.clearInstanceListeners(iw);
				};
			}
		}, []); // eslint-disable-line react-hooks/exhaustive-deps

		return null;
	};
	EnhancedInfoWindow.propTypes = {
		content: PropTypes.node,
		google: PropTypes.shape({
			maps: PropTypes.shape({
				InfoWindow: PropTypes.func,
				Size: PropTypes.func,
				LatLng: PropTypes.func,
				event: PropTypes.shape({
					addListener: PropTypes.func,
					clearInstanceListeners: PropTypes.func,
				}),
			}),
		}),
		map: PropTypes.object,
		location: PropTypes.shape({
			latitude: PropTypes.number,
			longitude: PropTypes.number,
		}),
		onClose: PropTypes.func,
	};
	return EnhancedInfoWindow;
};

export default enhance();
